import React from 'react';
import { Button } from '@mui/material';
import { ConnectAsUser } from '../../../icons/ConnectAsUser';

type AdminLoginButtonProps = {
  text: string,
  loginAsAdminClick: () => void,
}

export const AdminLoginButton = ({
  text,
  loginAsAdminClick,
}: AdminLoginButtonProps):JSX.Element => {
  return (
    <Button
      variant="text"
      onClick={ loginAsAdminClick }
      startIcon={ <ConnectAsUser /> }
    >
      { text }
    </Button>
  );
};
